export default __webpack_public_path__ + "static/media/image3.ea69442a.jpg";